import { addExpenseToBasket } from 'api/v2/expenses/basket';
import useMutation from 'hooks/react-query/useMutation';

import useGetBasket from './useGetBasket';

const useAddExpenseToBasket = (onSuccess?: () => void) => {
  const basketQuery = useGetBasket();

  return useMutation(addExpenseToBasket, {
    onSuccess: () => {
      basketQuery.refetch();
      onSuccess?.();
    },
  });
};

export default useAddExpenseToBasket;
